import { Alert } from '@mui/material';

export const IntegrationDisplayNameWarningAlert = () => {
  return (
    <Alert variant="outlined" severity="warning">
      PS: The chosen name will be prominently displayed on all feedback records
      from this integration. Please ensure the name is easy for end-users to
      understand and accurately represents the true source of the feedback. Once
      integrated, this name cannot be changed.
    </Alert>
  );
};
